import script from "./FilePermitionsUserGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePermitionsUserGroupList.vue?vue&type=script&setup=true&lang=ts"

import "./FilePermitionsUserGroupList.vue?vue&type=style&index=0&id=09b2beaf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b2beaf"]])

export default __exports__